import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchDraft } from '../engine/persistence';
import { getSchemaBySlug } from '../engine/registry';
import NotFound from './NotFound';

export default function AssessmentResume() {
  const { slug = '', uuid = '' } = useParams();
  const schema = getSchemaBySlug(slug);
  const navigate = useNavigate();

  useEffect(() => {
    if (!schema) return;
    fetchDraft(schema.id, uuid).then((draft) => {
      if (!draft) {
        navigate(`/${schema.slug}/`);
        return;
      }
      sessionStorage.setItem(`assessment:${schema.id}:uuid`, uuid);
      sessionStorage.setItem(`assessment:${schema.id}:startedAt`, draft.startedAt);
      sessionStorage.setItem(`assessment:${schema.id}:answers`, JSON.stringify(draft.answers));
      navigate(`/${schema.slug}/q/1/`);
    });
  }, [schema, uuid, navigate]);

  if (!schema) return <NotFound />;
  return <p>Resuming your assessment…</p>;
}
